import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getEbusReservation = async (id) => {
  try {
      const response = await apiWrapper("GET", `reservations/${id}`,
        null,
        false,
        false,
        "E-BUS");
      console.log("getEbusReservation response.data :>> ", response.data);
      store.commit("demand/setReservation", response.data);
  } catch (err) {
    console.log('ERROR"" getEbusReservation():', err);
    throw err;
  }
};
